export default {
  navigation: [],

  cities: [
    { header: 'Biobío' },
    { text: 'Laja', group: 'Biobío' },
    { text: 'Mininco', group: 'Biobío' },
    { text: 'Mulchén', group: 'Biobío' },
    { text: 'Nacimiento', group: 'Biobío' },
    { header: 'Metropolitana' },
    { text: 'Buin', group: 'Metropolitana' },
    { text: 'Puente alto', group: 'Metropolitana' },
    { text: 'Santiago', group: 'Metropolitana' }
  ],
}
